export const GetNumber = ({n}) => "+" + n[0] + " (" + n.slice(1, 4) + ") " + n.slice(4, 7) + "-" + n.slice(7, 9) + "-" + n.slice(9, 11)